import { render, staticRenderFns } from "./imageMarkWrapperforselfcheck.vue?vue&type=template&id=48744412&scoped=true&"
import script from "./imageMarkWrapperforselfcheck.vue?vue&type=script&lang=js&"
export * from "./imageMarkWrapperforselfcheck.vue?vue&type=script&lang=js&"
import style0 from "./imageMarkWrapperforselfcheck.vue?vue&type=style&index=0&id=48744412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48744412",
  null
  
)

export default component.exports